import { instance } from "libs/api";

import { ApiRoutesFinancialReport } from "../../constants";
import { FinancialSettings } from "../financialReport.types";

export const requestFinancialSettings =
  async (): Promise<FinancialSettings> => {
    return await instance.get(ApiRoutesFinancialReport.Settings);
  };
